import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { popover } from './popover.model';

@Component({
  selector: 'app-popover-loader',
  templateUrl: './popover-loader.component.html',
  styleUrls: ['./popover-loader.component.scss']
})

export class PopoverLoaderComponent implements OnInit, AfterViewInit {

  constructor() { }

  @Input() config: popover;
  @Output() callemit = new EventEmitter;
  @Input() show;
  @Output() hideel = new EventEmitter;

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.show) {
      let count = 1;
      document.addEventListener('click', (item: any) => {
        if (!item?.target?.className?.match('popover-container') && count !== 1) {
          this.show = false;
          this.hideel.emit(false);
          count = 1;
        }
        count = 2;
      });
    }
  }

  emit() {
    this.callemit.emit(true);
  }

}
